module.exports = __webpack_public_path__ + "ve.svg?f49a8d433ff0bab2503420518c856519";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ve.svg
// module id = 1164
// module chunks = 27